import React, { useMemo } from 'react';

import ChargingPointIconView from './ChargingPointIcon.view';
import { ConnectorPowerType, ConnectorStatus } from 'utils/enums/chargingType';
import { MIconName } from 'views/MIcon/MIcon.model';
import { RiChargingPileFill, RiWirelessChargingLine } from 'react-icons/ri';
import { BsBatteryCharging } from 'react-icons/bs';

type Props = {
  status: ConnectorStatus;
  mostConnectorPowerType: ConnectorPowerType;
  id: number;
  isChosen: boolean;
};

const ChargingPointIcon: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const icon: MIconName = useMemo(() => {
    return props.mostConnectorPowerType === ConnectorPowerType.AC_1_phase 
      ? RiChargingPileFill // Slow
      : props.mostConnectorPowerType === (ConnectorPowerType.AC_2_phase || ConnectorPowerType.AC_2_phase_split)
        ? BsBatteryCharging  //Fast
        : RiWirelessChargingLine; //Turbo
  }, [props.mostConnectorPowerType]);

  return (
    <ChargingPointIconView isChosen={props.isChosen} id={props.id} status={props.status} icon={icon}>
      {props.children}
    </ChargingPointIconView>
  );
};

ChargingPointIcon.displayName = 'ChargingPointIcon';
ChargingPointIcon.defaultProps = {};

export default ChargingPointIcon;
